import axios from "axios";

export const saveProfileCompletion = (completion) => {
  if (!completion) return;
  localStorage.setItem("ProfileCompletion", JSON.stringify(completion));
  localStorage.setItem("Profile_ratio", String(completion.completion_percent || 0));
  window.dispatchEvent(new CustomEvent("gomeet:profile-completion-updated", {
    detail: completion,
  }));
};

export const getProfileCompletion = () => {
  try {
    return JSON.parse(localStorage.getItem("ProfileCompletion") || "null");
  } catch {
    return null;
  }
};

export const syncRegisterUser = async (basUrl, uid) => {
  if (!uid) return null;
  const res = await axios.post(`${basUrl}user_info`, { uid });
  const userInfo = res.data.userinfo || res.data.UserLogin || res.data.user;
  if (res.data.Result === "true" && userInfo) {
    const current = JSON.parse(localStorage.getItem("Register_User") || "{}");
    const token = current.token || localStorage.getItem("token") || "";
    const nextUser = { ...current, ...userInfo, id: String(userInfo.id), token };
    localStorage.setItem("Register_User", JSON.stringify(nextUser));
    window.dispatchEvent(new CustomEvent("gomeet:user-updated", {
      detail: nextUser,
    }));
    return nextUser;
  }
  return null;
};

export const fetchProfileCompletion = async (basUrl, uid) => {
  const res = await axios.post(`${basUrl}profile_completion`, uid ? { uid } : {});
  if (res.data.Result === "true" && res.data.profile_completion) {
    saveProfileCompletion(res.data.profile_completion);
    await syncRegisterUser(basUrl, uid).catch(() => null);
    return res.data.profile_completion;
  }
  return null;
};

export const getDiscoveryBlockMessage = (completion) => {
  if (!completion || Number(completion.can_discover) === 1) return "";
  const missing = (completion.missing_tasks || [])
    .filter((task) => task.is_required && task.blocks_discovery)
    .slice(0, 3)
    .map((task) => task.title)
    .join(", ");
  return missing
    ? `Complete your profile first: ${missing}`
    : "Complete your profile to start discovering people.";
};

export const getChatBlockMessage = (completion) => {
  if (!completion || Number(completion.can_chat) === 1) return "";
  const missing = (completion.missing_tasks || [])
    .filter((task) => task.is_required)
    .slice(0, 3)
    .map((task) => task.title)
    .join(", ");
  return missing
    ? `Complete your profile before chat: ${missing}`
    : "Complete your profile before using chat.";
};
